import * as PIXI from 'pixi.js';
import Vector from '../Game/Base/Math/Vector';
import CanvasButton from './CanvasButton';

export default class CanvasImageButton extends CanvasButton {
    constructor(parent, image) {
        super(parent);

        this.position = new Vector(0, 0);

        this.image = image;
    }

    checkUICollision(position) {
        if (!this._hasVisuals)
            return false;
        const pixiPoint = new PIXI.Point();
        this.pixiContainer.worldTransform.applyInverse(position.makePIXIPoint(), pixiPoint);
        const buttonSpacePosition = Vector.fromPIXIPoint(pixiPoint);

        if (buttonSpacePosition.x < -this.pixiContainer.width / 2)
            return false;
        if (buttonSpacePosition.y < -this.pixiContainer.height / 2)
            return false;
        if (buttonSpacePosition.x > +this.pixiContainer.width / 2)
            return false;
        if (buttonSpacePosition.y > +this.pixiContainer.height / 2)
            return false;

        return true;
    }

    onCreateVisuals() {
        this.pixiContainer = new PIXI.Sprite(this.image);
        this.pixiContainer.x = this.position.x;
        this.pixiContainer.y = this.position.y;
        this.pixiContainer.anchor.set(0.5);
        this.getParentPixiContainer().addChild(this.pixiContainer);
    }

    onUpdateVisuals() {
        this.pixiContainer.x = this.position.x;
        this.pixiContainer.y = this.position.y;
    }

    onDestroyVisuals() {
        this.pixiContainer.destroy();
    }
}